import { useEffect, useRef, useState } from 'react';
import { errorCopy } from '@/features/networks/service';
/** Mount each editor under an account key. Ignore late responses after it closes. */
export function useStudioTask() {
  const alive = useRef(true);
  const locked = useRef(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  useEffect(() => {
    alive.current = true;
    return () => {
      alive.current = false;
    };
  }, []);
  async function run<T>(work: () => Promise<T>, done: (value: T) => void) {
    if (locked.current) return;
    locked.current = true;
    setBusy(true);
    setError('');
    try {
      const result = await work();
      if (alive.current) done(result);
    } catch (e) {
      if (alive.current) setError(errorCopy(e));
    } finally {
      locked.current = false;
      if (alive.current) setBusy(false);
    }
  }
  return { busy, error, run, setError };
}
